import scraperApi from "api";
import { BillingInputName, CouponInputName } from "v2/dataroutes/BillingData";
import { CheckCouponsDataRouteType } from "routes/data-routes/billing-data/coupons/check-coupons/route.meta";


export const loader: CheckCouponsDataRouteType["route"]["loader"] = async ({ request }) => {
  const url = new URL(request.url);
  const couponCode = url.searchParams.get(CouponInputName.couponCode);
  const required = url.searchParams.get("required") === "true";

  if (!couponCode) {
    // empty coupon code input, clear coupon data
    return {
      coupon: {
        coupon_name: "",
        coupon_code: "",
        error: required ? "Coupon code must not be empty" : undefined
      }
    };
  }

  const targetPlanId = url.searchParams.get(BillingInputName.targetPlanSlug);
  const activeCouponCodes = url.searchParams.getAll(CouponInputName.activeCouponCode);
  if (activeCouponCodes?.includes(couponCode!)) {
    return {
      coupon: {
        coupon_code: couponCode,
        error: "That coupon has already been used."
      }
    };
  }

  try {
    const couponResponse = await scraperApi.billing.coupons.checkCoupons([ couponCode ], targetPlanId || undefined, { signal: request.signal });
    if (couponResponse && couponResponse.length > 0) {
      return { coupon: couponResponse[0] };
    } else {
      return {
        coupon: {
          coupon_code: couponCode,
          error: "Unexpected error while checking coupon code"
        }
      };
    }
  } catch (err) {
    return {
      coupon: {
        coupon_code: couponCode,
        error: (err as Error).message
      }
    };
  }
}
